/* eslint-disable @typescript-eslint/consistent-type-definitions */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import * as React from "react";
import "./project-show.css"
import { LandfillSiteProject } from "../../../stores/project/project";
import { Grid, GridColumn, GridRow } from "semantic-ui-react";
import LabeledValue from "../../../components/labeled-value/labeled-value";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import { getDesc, getLabel } from "../../../reflection/reflection";

export default function LandfillSiteShow({ project }: { project: LandfillSiteProject }): JSX.Element {
    return (
        <div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridRow>
                    <GridColumn largeScreen={16} widescreen={8}>
                        <LabeledValue
                            label={getLabel(LandfillSiteProject.prototype, "fullType")}
                            value={project.type}
                        />
                        <LabeledValue
                            label={getLabel(project, "municipalityName")}
                            desc={getDesc(project, "municipalityName")}
                            value={project.municipalityName}
                        />
                        <LabeledValue
                            label={getLabel(project, "place")}
                            desc={getDesc(project, "place")}
                            value={project.place}
                        />
                        <LabeledValue
                            label={getLabel(project, "landfillSiteType")}
                            desc={getDesc(project, "landfillSiteType")}
                            value={project.landfillSiteType}
                        />
                        <LabeledValue
                            label={getLabel(project, "status")}
                            desc={getDesc(project, "status")}
                            value={project.status}
                        />
                        <LabeledValue
                            label={getLabel(project, "governmentCouncilDecisionNr")}
                            desc={getDesc(project, "governmentCouncilDecisionNr")}
                            value={project.governmentCouncilDecisionNr}
                        />
                        <LabeledValue
                            label={getLabel(project, "ebageNr")}
                            desc={getDesc(project, "ebageNr")}
                            value={project.ebageNr}
                        />
                        <LabeledValue
                            label={getLabel(project, "enactmentDateDisplayText")}
                            desc={getDesc(project, "enactmentDateDisplayText")}
                            value={project.enactmentDateDisplayText}
                        />
                        <LabeledValue
                            label={getLabel(project, "constructionPermitDateDisplayText")}
                            desc={getDesc(project, "constructionPermitDateDisplayText")}
                            value={project.constructionPermitDateDisplayText}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "approvedCreationArea")}
                            desc={getDesc(project.recultivationProject, "approvedCreationArea")}
                            value={project.recultivationProject.approvedCreationArea?.toLocaleString()}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "creationGoalSource")}
                            value={project.recultivationProject.creationGoalSource}
                        />
                        <LabeledValue
                            label={getLabel(project, "cmiDocumentsRawiPre")}
                            desc={getDesc(project, "cmiDocumentsRawiPre")}
                            value={project.cmiDocumentsRawiPre.join(", ")}
                        />
                        <LabeledValue
                            label={getLabel(project, "cmiDocumentsUwePre")}
                            desc={getDesc(project, "cmiDocumentsUwePre")}
                            value={project.cmiDocumentsUwePre.join(", ")}
                        />
                    </GridColumn>
                    <GridColumn>
                        <LabeledValue
                            label={getLabel(project, "cmiDocumentsRawiApproved")}
                            desc={getDesc(project, "cmiDocumentsRawiApproved")}
                            value={project.cmiDocumentsRawiApproved.join(", ")}
                        />
                        <LabeledValue
                            label={getLabel(project, "cmiDocumentsUweApproved")}
                            desc={getDesc(project, "cmiDocumentsUweApproved")}
                            value={project.cmiDocumentsUweApproved.join(", ")}
                        />
                        <LabeledValue
                            label={getLabel(project, "geometrySource")}
                            desc={getDesc(project, "geometrySource")}
                            value={project.geometrySource}
                        />
                        <LabeledValue
                            label={getLabel(project, "geometrySourceDateDisplayText")}
                            desc={getDesc(project, "geometrySourceDateDisplayText")}
                            value={project.geometrySourceDateDisplayText}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "approvedRecultivationArea")}
                            desc={getDesc(project.recultivationProject, "approvedRecultivationArea")}
                            value={project.recultivationProject.approvedRecultivationArea?.toLocaleString()}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "constructionSupervisorFullName")}
                            value={project.recultivationProject.constructionSupervisorFullName}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "operatingPermitDateDisplayText")}
                            desc={getDesc(project.recultivationProject, "operatingPermitDateDisplayText")}
                            value={project.recultivationProject.operatingPermitDateDisplayText}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "maintenanceDirectiveDateDisplayText")}
                            desc={getDesc(project.recultivationProject, "maintenanceDirectiveDateDisplayText")}
                            value={project.recultivationProject.maintenanceDirectiveDateDisplayText}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "requirementsSpecificationBBBStatus")}
                            desc={getDesc(project.recultivationProject, "requirementsSpecificationBBBStatus")}
                            value={project.recultivationProject.requirementsSpecificationBBBStatus}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "requirementsSpecificationRequestSource")}
                            desc={getDesc(project.recultivationProject, "requirementsSpecificationRequestSource")}
                            value={project.recultivationProject.requirementsSpecificationRequestSource}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "startConstructionMeetingStatus")}
                            desc={getDesc(project.recultivationProject, "startConstructionMeetingStatus")}
                            value={project.recultivationProject.startConstructionMeetingStatus}
                        />
                        <LabeledValue
                            label={getLabel(project.recultivationProject, "startConstructionMeetingSource")}
                            desc={getDesc(project.recultivationProject, "startConstructionMeetingSource")}
                            value={project.recultivationProject.startConstructionMeetingSource}
                        />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn>
                        <LabeledTextArea
                            label={getLabel(project, "remarks")}
                            name="remarks"
                            defaultValue={project.remarks}
                            disabled={true}/>
                        <LabeledTextArea
                            label={getLabel(project.recultivationProject, "enactmentRemarks")}
                            name="remarks"
                            defaultValue={project.recultivationProject.enactmentRemarks}
                            disabled={true}/>
                        <LabeledTextArea
                            label={getLabel(project.recultivationProject, "creationGoalRemarks")}
                            name="remarks"
                            defaultValue={project.recultivationProject.creationGoalRemarks}
                            disabled={true}/>
                    </GridColumn>
                </GridRow>
            </Grid>
        </div>
    );
}
